var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 35,
    viewBox: "0 0 46 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7886 3.91955C14.5464 6.74933 14.334 9.95184 15.5599 12.6541C17.5002 16.9356 20.2658 10.045 21.7813 8.65711C23.5815 7.00926 26.4581 5.19957 28.437 7.09754C30.411 8.9906 30.6282 12.5756 31.1881 15.121C31.608 17.0189 32.1823 21.7712 34.6583 22.1685C37.2308 22.5853 39.3593 17.7301 42.1345 19.3828C44.3643 20.7119 45.3924 25.5083 45.4986 27.882C45.5903 29.8878 45.2717 35.003 42.3179 34.8608C41.8739 34.8412 41.1016 34.4587 40.5804 33.9878C40.3294 33.8015 40.1026 33.5465 39.9191 33.1982C38.8139 31.1335 41.1161 26.1115 38.0754 25.3415C35.0106 24.5667 33.5482 29.4514 30.884 30.2557C27.9302 31.1482 26.1058 27.3768 25.9755 24.7432C25.8886 22.9924 27.7757 18.3235 26.2409 16.7345C24.1945 14.6207 20.8835 19.4221 19.5804 20.3637C17.5436 21.835 14.2327 23.5221 12.4372 20.8639C10.6225 18.1813 11.2982 14.6698 10.4198 11.6929C10.0916 10.5894 9.6813 9.35842 8.44572 9.07397C6.99296 8.74048 6.25933 10.4128 5.32782 11.3398C4.32874 12.3304 3.24762 13.478 1.83346 12.5364C0.757156 11.8155 0.428955 10.56 0.742676 9.39766C1.87207 5.20938 11.7663 -3.62327 13.7886 3.91955Z",
    fill: "#EA63C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.8862,
    height: 33.8937,
    fill: "white",
    transform: "matrix(-1 0 0 1 45.5132 0.97168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector-4.6b051e4c589027ec781e75331dd7d7e5.svg";
export { ForwardRef as ReactComponent };